module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main mb2 main--full-height"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "grid grid--auth"
  }, [_c('div', {
    staticClass: "grid__item grid__item--4 hide-below-medium"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--2"
  }, [_c('ui-auth', {
    attrs: {
      "id": "confirm"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fba41cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Confirm.vue
// module id = 489
// module chunks = 0